import React from 'react';
import OverlayWrapper from './OverlayWrapper';

export default function Modal(props) {
    return (
        <OverlayWrapper id="xs-generic-overlay">
            <div className="xs_modal z-50 absolute top-0 left-0 right-0 bottom-0 pt-32 flex justify-center backdrop-brightness-50 backdrop-blur-sm">
                <div className="inline w-80 h-fit flex flex-col bg-cs1 text-cs9 rounded-md drop-shadow-lg">
                    <div className="h-12 px-3 py-2 bg-cs13 grid grid-cols-12 items-center font-bold text-cs1 fill-cs1 rounded-t-md">
                        <span className="col-start-1 col-end-12">{props.title}</span>
                        <span className="col-start-12 col-end-13" onClick={props.onClick}>
                            <i className="bi-x-lg" />
                        </span>
                    </div>
                    {props.children}
                </div>
            </div>
        </OverlayWrapper>
    );
}
